import React from 'react'
import { EyeIcon } from '@/components/icons/eye-icon'
import { EyeOffIcon } from '@/components/icons/eye-off-icon'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { TooltipIconButton } from '@/components/ui/tooltip-icon-button'
import { T, useTranslate } from '@tolgee/react'
import { Field } from 'react-final-form'

type ApiKeyFieldProps = {
  disabled?: boolean
}

export function ApiKeyField({ disabled = false }: ApiKeyFieldProps) {
  const { t } = useTranslate()
  const [inputType, setInputType] = React.useState('password')

  return (
    <Field name='key'>
      {({ input }) => (
        <div>
          <Label htmlFor={input.name} variant='dialog-field'>
            <T keyName='serviceRegistry.dialog.fields.apiKey.label' />*
          </Label>
          <div className='flex items-center gap-1'>
            <Input
              type={inputType}
              placeholder={t('serviceRegistry.dialog.fields.apiKey.placeholder')}
              disabled={disabled}
              required
              {...input}
            />
            <TooltipIconButton
              size={'auto'}
              onClick={() => setInputType((prev) => (prev === 'password' ? 'text' : 'password'))}
              titleString={
                inputType === 'password'
                  ? t('serviceRegistry.dialog.connection.show')
                  : t('serviceRegistry.dialog.connection.hide')
              }
            >
              {inputType === 'password' ? (
                <EyeOffIcon className='text-neutral-150' />
              ) : (
                <EyeIcon className='text-neutral-150' />
              )}
            </TooltipIconButton>
          </div>
        </div>
      )}
    </Field>
  )
}
